<script>
	import Button from '$lib/Components/Layout/Button/Button.svelte';
	import ContentLink from '$lib/Components/Layout/ContentLink/ContentLink.svelte';
	import Section from '$lib/Components/Layout/Section/Section.svelte';
	import { featured } from '$routes/(public)/resources/case-studies/casestudies-data.js';

	let {
		backgroundColor = 'white',
		class: className = null,
		innerClass = null,
		title = 'Case Studies',
	} = $props();
</script>

<Section {backgroundColor} {title} class={className} {innerClass}>
	<ul
		class="
    mb-6 grid list-none grid-cols-1 gap-x-4 gap-y-6
    md:grid-cols-2
  "
	>
		{#each featured.flatMap((group) => group.items) as { title, subtitle, href, header, image } (href)}
			<li>
				<ContentLink {title} {subtitle} {href} {header} {image} />
			</li>
		{/each}
	</ul>
	<Button href="/resources/case-studies">Read More</Button>
</Section>
